import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import { noop } from '~/services/util';

const CategoryHeader = () => (
    <div className="d-flex mx-0 py-4 desktop-screen">
        <div className="d-flex-3 dsl-m12">Category</div>
        <div className="d-flex-1 dsl-m12 text-center">posts</div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-comment" size={12} />
        </div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-eye" size={12} />
        </div>
        <div className="d-flex-3 dsl-m12">Latest post</div>
        <div className="d-flex-1" />
    </div>
);

const CategoryItem = ({ item, onClick, enable, onSelect }) => {
    const { name, latest, stats } = item;
    return (
        <div className="d-flex cursor-pointer mx-0 py-3">
            <div className="d-flex ssm-column d-flex-12" onClick={() => onClick(item)}>
                <div className="d-flex pb-3 d-flex-3">
                    <div className="d-flex-3 dsl-b16">{name}</div>
                    <div className="d-flex-1 d-h-end mobile-screen">{enable && <EditDropdown options={['Edit', 'Delete']} onChange={onSelect(item)} />}</div>
                </div>
                <div className="d-flex d-flex-1 py-2 ms-0 ssm-l-3">
                    <label className="dsl-b16 mb-0 w-40 mobile-screen">posts</label>
                    <div className="d-flex-1 text-center dsl-b16">{stats?.posts}</div>
                </div>
                <div className="d-flex d-flex-2 py-2 ms-0 ssm-l-3">
                    <label className="dsl-b16 mb-0 w-40 mobile-screen">
                        <Icon name="far fa-comment" size={12} />
                    </label>
                    <div className="d-flex-2 text-center dsl-b16">{stats?.comments}</div>
                </div>
                <div className="d-flex d-flex-2 py-2 ms-0 ssm-l-3">
                    <label className="dsl-b16 mb-0 w-40 mobile-screen">
                        <Icon name="far fa-eye" size={12} />
                    </label>
                    <div className="d-flex-2 text-center dsl-b16">{stats?.views}</div>
                </div>
                <div className="d-flex d-flex-3 py-2 ms-0 ssm-l-3">
                    <label className="dsl-b16 mb-0 w-40 mobile-screen">Latest post</label>
                    <div className="d-flex-3 text-center dsl-b14 truncate-one text-500">{latest?.name}</div>
                </div>
            </div>
            <div className="d-flex-1 d-h-end desktop-screen">{enable && <EditDropdown options={['Edit', 'Delete']} onChange={onSelect(item)} />}</div>
        </div>
    );
};

const CategoryDetailedItem = ({ post }) => {
    const { name, data, created_at } = post;
    return (
        <>
            <div className="d-h-between">
                <div className="d-h-start">
                    <Avatar type="logo" url={post.author_avatar} isSponsored={true} />
                    <div className="ml-2">
                        <p className="dsl-m14 mb-2">{`${post.author?.first_name} ${post.author?.last_name}`}</p>
                        <p className="dsl-m14 mb-0">{post.profile?.company}</p>
                    </div>
                </div>
                <p className="dsl-m14 mb-0">{moment(created_at).format('MMM DD, YY')}</p>
            </div>
            <p className="dsl-b18 bold my-3 truncate-two">{name}</p>
            <div className="post-body" dangerouslySetInnerHTML={{ __html: data?.body }} />
        </>
    );
};

export const CategoryFeed = ({ category, posts, onChangePage }) => {
    if (!category) return null;

    const { name } = category;

    const handlePagination = (page) => {
        if (onChangePage) {
            onChangePage({ blog_categories: name, page });
        }
    };

    return (
        <div className="bg-white">
            <p className="dsl-b20 bold pt-3 ps-3 mb-0 mt-3">{name}</p>
            {posts?.data &&
                posts.data.map((item) => {
                    if (item.data?.blog_categories && item.data?.blog_categories.includes(name)) {
                        return (
                            <div className="blog-category-section" key={`item-${item.id}`}>
                                <CategoryDetailedItem post={item} />
                            </div>
                        );
                    }
                    return null;
                })}
            {(!posts || posts?.total === 0) && <p className="dsl-b16 p-3">{`There are no ${name.toLowerCase()} posts.`}</p>}
            {posts?.last_page > 1 && <Pagination pers={[]} current={posts.current_page} perPage={posts.per_page} total={posts.last_page} onChange={handlePagination} />}
        </div>
    );
};

const Categories = ({ categories, onDetail = noop, onSelect }) => {
    const handleOpenDetail = (item) => {
        onDetail(item);
    };
    return (
        <div className="card blog-category-section my-3 p-0 p-sm-3">
            {categories.length > 0 ? (
                <>
                    <p className="dsl-b20 bold my-2">Public</p>
                    <CategoryHeader />
                    {categories.map((category, index) => (
                        <CategoryItem key={`category-${index}`} item={category} onClick={handleOpenDetail} enable={category.name !== 'Uncategorized'} onSelect={onSelect} />
                    ))}
                </>
            ) : (
                <p className="dsl-b16 p-3">{`There are no categories.`}</p>
            )}
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.array,
    onSelect: PropTypes.func,
};

Categories.defaultProps = {
    categories: [],
    onSelect: () => {},
};

export default Categories;
